import { useEffect, useState } from "react";
import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import QUDProgress from "../../../../../components/progress";
import ResponseComponent from "../../../../../components/responseComponent";
import CustomBreadcrumbs from "../../../../../components/breadcrumbs";
import SectionTitle from "../../../../../components/sectionTitle";
import { showModifierOption, updateModifierOption } from "../../../../../controllers/company/products/ModifierOptionsController";


export default function ModifierOptionUpdate()
{
    const [modifier_group_id,setModifierGroupId] = useState('');
    const [name,setName] = useState('');
    const [errorName,setErrorName] = useState(false);
    
    const [price,setPrice] = useState('');
    const [errorPrice,setErrorPrice] = useState(false);

    const [quantity,setQuantity] = useState(0);
    const [errorQuantity,setErrorQuantity] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);

    const history = useHistory();
    const { modifierId } = useParams();

    useEffect(()=>{
        window.scrollTo(0,0);
        handleShowModifier();
    },[]);

    const handleShowModifier = async () => {
        setIsLoading(true);
        const response = await showModifierOption(modifierId);
        if(response.success === true)
        {
            setModifierGroupId(response.data.modifier_group_id);
            setName(response.data.name);
            setPrice(response.data.price);
        }
        setIsLoading(false);
    }

    const formVerification = () => {
        let ban = 0;

        if(name === '')
        {
            setErrorName(true);
            ban = 1;
        }

        return ban;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formVerification()===0)
        {
            setIsLoading(true);
            const response = await updateModifierOption(modifierId,name,price);
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccess(true);
                setOpen(true);
            }
            else
            {
                setTitle('Operación Fallida');
                setMessage(response.message);
                setSuccess(false);
                setOpen(true);
            }

            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        if(success === true)
        {
            history.push('/products/modifiergroups/options/'+modifier_group_id);
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo={`/products/modifiergroups/options/${modifier_group_id}`}
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Extras',link:'/products/modifiergroups'},
                    {name:'Opciones',link:'/products/modifiersgroups/options/'+modifier_group_id},
                    {name:'Editar',link:`/products/modifiergroups/options/${modifierId}/update`}
                ]}
            />
            <br/>
            <SectionTitle title={name} subtitle={`(Extras)`} />

            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item lg={4} xl={4}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                label='Nombre'
                                fullWidth
                                value={name}
                                onChange={(e)=>setName(e.target.value)}
                                onBlur={()=>setErrorName(name==='')}
                                error={errorName}
                                helperText={errorName?<Typography>El nombre es obligatorio</Typography>:''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label='Precio'
                                id="price"
                                name="price"
                                value={price}
                                onChange={(e)=>setPrice(e.target.value)}
                                onBlur={()=>setErrorPrice(price==='')}
                                error={errorPrice}
                                helperText={errorPrice?<Typography>El precio es obligatorio</Typography>:''}
                            />
                        </Grid>

                        
                    </Grid>
                    
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{mt:2}}
                        onClick={(e)=>handleSubmit(e)}
                    >
                        <Typography>Actualizar opción</Typography>
                    </Button>
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
            />
        </Container>
    )
}